export function createSimpleIcon(icon: { path: string; title?: string }) {
  // eslint-disable-next-line react/display-name
  return ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className} // Apply className
      {...props}
    >
      <path d={icon.path} fill="currentColor" />{' '}
      {/* Use currentColor for coloring */}
    </svg>
  );
}
